<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="9" class="mx-auto">
        <h1 class="title font-weight-light mb-2 black--text">
          <v-icon left color="black">mdi-server</v-icon>
          <span id="widgetNameEdit"> {{ $t("PANEL.MODULE.LIST.TITLE") }} </span>
          <v-divider class="mt-2"></v-divider>
        </h1>
        <p class="text-caption grey--text text--darken-2 mb-2">
          {{ $t("PANEL.MODULE.LIST.SUB_TITLE") }}
        </p>
      </v-col>
      <v-col cols="12" lg="8" class="mx-auto" v-if="!modulesList.length">
        <v-skeleton-loader class="mb-4 elevation-1" type="list-item"></v-skeleton-loader>
        <v-skeleton-loader class="mb-4 elevation-1" type="list-item"></v-skeleton-loader>
        <v-skeleton-loader class="mb-4 elevation-1" type="list-item"></v-skeleton-loader>
        <v-skeleton-loader class="mb-4 elevation-1" type="list-item"></v-skeleton-loader>
        <v-skeleton-loader class="mb-4 elevation-1" type="list-item"></v-skeleton-loader>
        <v-skeleton-loader class="mb-4 elevation-1" type="list-item"></v-skeleton-loader>
      </v-col>
      <v-col v-else cols="12" lg="8" class="mx-auto py-2" :key="key" v-for="(module, key) in modulesList">
        <v-card>
          <v-row class="d-flex align-center mx-0">
            <v-col cols="12" lg="3">
              <v-icon size="20" color="#333" left>mdi-view-module</v-icon>
              <span class="text-body-2" :class="[module.type === 'fake' ? 'red--text' : '']">
                {{ module.localename }}
              </span>
            </v-col>
            <v-col class="grey--text text-caption">
              <v-btn v-if="module.status === 1" color="green lighten-1" class="text-overline font-weight-bold" width="60" outlined dark small>
                <span class="aktif-pasif-text"> {{ $t("PANEL.MODULE.LIST.ITEM_ACTIVE") }} </span>
              </v-btn>
              <v-btn v-else color="red" width="60" dark outlined small>
                <span class="aktif-pasif-text"> {{ $t("PANEL.MODULE.LIST.ITEM_PASSIVE") }} </span>
              </v-btn>

              <v-tooltip v-if="module.status !== 1" bottom max-width="200" color="red darken-2">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-2" small v-bind="attrs" v-on="on" icon>
                    <v-icon size="18">mdi-alert-decagram</v-icon>
                  </v-btn>
                </template>
                <span>
                  <span class="d-block text-center" v-html="$t('PANEL.MODULE.LIST.ITEM_INFORMATION_FAILED')"> </span>
                </span>
              </v-tooltip>
            </v-col>
            <v-col v-if="module.status === 1" class="grey--text text-caption"> {{$t('PANEL.MODULE.LIST.ITEM_VERSION')}}: {{ module.version }}</v-col>
            <v-spacer></v-spacer>
            <v-col class="d-flex justify-end" cols="2">
              <v-tooltip bottom color="blue darken-2">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" icon @click="moduleSettings(module.name)">
                    <v-icon color="#555" size="18">mdi-cog</v-icon>
                  </v-btn>
                </template>
                <span> {{ $t("PANEL.MODULE.LIST.ITEM_SETTINGS_BTN") }} </span>
              </v-tooltip>
              <div class="ml-1"></div>
              <v-tooltip bottom color="blue darken-2">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" icon @click="moduleInfo(module.localename, module.localedesc)">
                    <v-icon size="18" color="blue lighten-2">mdi-information</v-icon>
                  </v-btn>
                </template>
                <span> {{ $t("PANEL.MODULE.LIST.ITEM_INFORMATION_BTN") }} </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <ModuleSettingsDialog v-model="moduleSettingsData.status" :name="moduleSettingsData.name" @click="settingsDialog" />

    <ModuleInfoDialog v-model="moduleInfoData.status" :name="moduleInfoData.name" :desc="moduleInfoData.desc" @input="infoDialog" />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ModuleSettingsDialog from "@/components/Settings/Modules/ModuleSettingsDialog";
import ModuleInfoDialog from "@/components/Settings/Modules/ModuleInfoDialog";

export default {
  name: "ModulesList",
  data() {
    return {
      moduleInfoData: {
        status: false,
        name: "",
        desc: ""
      },
      moduleSettingsData: {
        status: false,
        name: ""
      }
    };
  },
  components: {
    ModuleSettingsDialog,
    ModuleInfoDialog
  },
  computed: {
    ...mapGetters({
      modulesList: "Module/ModulesList/modulesList"
    })
  },
  methods: {
    /**
     * Module Settings Dialog için bilgileri alır
     * ve değerlere aktarır
     */
    moduleSettings(name) {
      this.moduleSettingsData.status = true;
      this.moduleSettingsData.name = name;
    },
    moduleInfo(name, desc) {
      this.moduleInfoData.status = true;
      this.moduleInfoData.name = name;
      this.moduleInfoData.desc = desc;
    },
    /**
     * Info Dialog component'ten kapat tıklandığında
     */
    infoDialog(data) {
      this.moduleInfoData.status = data;
    },
    /**
     * Settings Dialog component'ten güncelle dendiğinde
     */
    settingsDialog(data) {
      this.moduleSettingsData.status = data;
    }
  },
  created() {
    this.$store.dispatch("Module/ModulesList/modulesList", {
      preverseState: true
    });
  }
};
</script>

<style>
.aktif-pasif-text {
  font-size: 10px;
}
</style>
